import { useCallback, useMemo } from 'react';

const usePersistentSortState = ({ storageKey, sortingKeys }) => {
  const initialTableState = useMemo(() => {
    if (typeof window === 'undefined') {
      return {};
    }

    try {
      const rawState = window.localStorage.getItem(storageKey);

      if (!rawState) {
        return {};
      }

      const parsedState = JSON.parse(rawState);
      const sortBy = Array.isArray(parsedState?.sortBy) ? parsedState.sortBy : [];
      const validSortBy = sortBy
        .filter((item) => item?.id && Object.prototype.hasOwnProperty.call(sortingKeys, item.id))
        .map((item) => ({ id: item.id, desc: Boolean(item.desc) }));

      return { sortBy: validSortBy };
    } catch (err) {
      return {};
    }
  }, [sortingKeys, storageKey]);

  const persistSortBy = useCallback(
    (sortBy) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify({ sortBy: sortBy || [] }));
      } catch (err) {
        // Ignore storage errors.
      }
    },
    [storageKey]
  );

  const getOrderByFromSortBy = useCallback(
    (sortBy) => {
      if (!sortBy?.[0]) {
        return undefined;
      }

      return [
        {
          column: sortingKeys[sortBy[0].id],
          order: sortBy[0].desc ? 'DESC' : 'ASC'
        }
      ];
    },
    [sortingKeys]
  );

  return {
    initialTableState,
    persistSortBy,
    getOrderByFromSortBy
  };
};

export default usePersistentSortState;